module.exports = __webpack_public_path__ + "fonts/Open_Sans-400-cyrillic-ext1.01b11c5.woff2";